import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsDocumentsListApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionsDocumentsList: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_conditions_documents_list/${credentials.loanGuid}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useEnhancedConditionsDocumentsListMutation } = fetchEnhancedConditionsDocumentsListApiSlice;
